import { gatewayApi } from './apiService';

// Support tickets via the API Gateway → support-service.
// (gatewayApi base = API_GATEWAY_URL; auth token attached by its interceptor.)
const PREFIX = '/support-service';

const unwrap = (r) => r.data;

export const ticketService = {
  // params: { service, scope: 'mine'|'all', status, page, limit }
  list: (params = {}) => gatewayApi.get(`${PREFIX}/tickets`, { params }).then(unwrap),
  getById: (id) => gatewayApi.get(`${PREFIX}/tickets/${id}`).then(unwrap),
  create: (data) => gatewayApi.post(`${PREFIX}/tickets`, data).then(unwrap),
  updateStatus: (id, status) => gatewayApi.patch(`${PREFIX}/tickets/${id}/status`, { status }).then(unwrap),
  addMessage: (id, body) => gatewayApi.post(`${PREFIX}/tickets/${id}/messages`, body).then(unwrap),
  // messageId (optional) scopes the attachment to a specific message of the ticket.
  uploadAttachment: (id, file, messageId = null) => {
    const fd = new FormData();
    fd.append('file', file);
    if (messageId) fd.append('message_id', messageId);
    return gatewayApi
      .post(`${PREFIX}/tickets/${id}/attachments`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(unwrap);
  },
  // Enum values (statuses / priorities / categories) — single source of truth.
  getOptions: () => gatewayApi.get(`${PREFIX}/meta/ticket-options`).then(unwrap),
};

export default ticketService;
